<template>
  <div>
    <v-dialog v-model="model" max-width="400" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Cadastrar Serviço</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-text-field
                    v-model="dadosGerais.titulo"
                    name="titulo"
                    placeholder="Informe o título"
                    counter="200"
                    maxlength="200"
                    v-validate="{required: true, min: 5, max: 200}"
                    :error-messages="errors.collect('titulo')">
                  <template v-slot:label>
                    Título <span class="ml-1 red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-textarea
                    v-model="dadosGerais.descricao"
                    name="descricao"
                    placeholder="Informe a descrição do serviço"
                    filled
                    auto-grow
                    counter="300"
                    maxlength="300"
                    v-validate="{required: true, min: 5, max: 300}"
                    :error-messages="errors.collect('descricao')">
                  <template v-slot:label>
                    Descrição
                    <span class="ml-1 red--text">*</span>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12">
                <input-valor
                    v-model="dadosGerais.valor"
                    label="Valor"
                    placeholder="Informe o valor do serviço"
                    hideDetails
                    :event-submit="'blur'"
                    :prefix="prefixo"
                    :suffix="sufixo"
                    :precision="casasDecimais"
                    @blur="(valor) => dadosGerais.valor = valor"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>

          <v-spacer/>
          <v-btn @click="fecharModal" outlined>Voltar</v-btn>
          <v-btn @click="cadastrarServico" depressed class="primary ml-5">Cadastrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import InputValor from '@/views/components/InputValor.vue'
import {actionTypes} from '@/core/constants'

export default {
    name: 'ServicoCadastroModal',
    components: {InputValor},
    props: {
        value: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            dadosGerais: {
                titulo: null,
                descricao: null,
                valor: null
            },
            prefixo: 'R$',
            sufixo: '',
            casasDecimais: 2,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        async cadastrarServico() {
            if (await this.validarDadosFormulario()) {
                this.setMensagemLoading('Cadastrando serviço...')
                await this.$store.dispatch(actionTypes.SERVICO.CADASTRAR_SERVICO, this.dadosGerais)
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModal()
            }
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalCadastrarServico')
        }
    }
}
</script>

<style scoped lang="stylus">


</style>